// Module
var code = "<div class=\"navbar-item\"> <a href=\"/app/auth\" class=\"button is-info\"><i class=\"fa-regular fa-circle-user right-margin\"></i>Log In</a> </div>";
// Exports
export default code;